import { FeiVO } from '../../vo/workingdata/fei.vo';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { BaselineEngine, FeiKeyDef, WidgetLine } from '@wizeoo/akm-compute-lib';
import { FreedataValueVO } from  '../../vo/core/freedatavalue.vo';
import { FreedataArgsVO } from  '../../vo/core/freedataargs.vo';
import { IWidget } from '../widgets/i-widget';
import { Model } from '../../model/model';

/**
 * l'objet pour alimenter un champ de saisie
 * contient la référence au FEI, et au WidgetConfigurationItemObj
 */
export class FormFieldObj {
  public widget: IWidget; // le widget source, pour pose des écouteurs
  
  public fei: FeiVO; // le fei source
  
  public wcio: WidgetConfigurationItemObj; // la configuration du champs

  public fkd: FeiKeyDef; // accesseur le pkdef pour rendu de la drop

  public model: Model = null; // passage du modèle pour la vue FDV (mode freedataMode)

  public widgetLine: WidgetLine = null; // passage de la widgetLine depuis les form BL

  public get label(): string { // le rendu intelligible (pour l'entête du filtre)
    let result: string = '';
    if(this.wcio.lbl) {
      result = this.wcio.lbl; 
    } else {
      if(this.freedataMode) {
        result = this.arg?.trsLabel || null;
      } else {
        if(this.fkd) {
          result = this.widget.model.feiEngine.getFeiKeyDefLabel(this.fkd);
        }
      }
    }
    
    return result; 
  } 

  constructor(widget: IWidget, fei: FeiVO, wcio: WidgetConfigurationItemObj, freedataMode: boolean = false, wl: WidgetLine = null) {
    this.widget = widget;
    this.fei = fei;
    this.wcio = wcio;
    this.freedataMode = freedataMode;
    this.widgetLine = wl;

    if(!this.freedataMode) { // override pour utilisation par les FDV
      this.fkd = BaselineEngine.getKey(this.fei, this.wcio.cod);
    }
  }


  /**
   * mode freedata
   */
  public freedataMode: boolean = false;
  public clone: FreedataValueVO;
  public arg: FreedataArgsVO;

  


}
